
var isAgent = false;
var Cal = function(container, cottageId, url, dayInfoUrl, front) {
  this.container = container;
  this.cottageId = cottageId;
  this.month = moment().month()+1;
  this.year = moment().year();
  this.url = url.replace('{cid}', cottageId);
  this.dayInfoUrl = dayInfoUrl;
  this.cache = {};
  this.front =  typeof front !== 'undefined' ? front : false;

  this.previousMonth = function() {
    this.month --;
    if (this.month == 0) {
      this.month = 12;
      this.year --;
    }
    this.getCalendar();
  }

  this.nextMonth = function() {
    this.month ++;
    if (this.month == 13) {
      this.month = 1;
      this.year ++;
    }
    this.getCalendar();
  }

  this.getCalendar = function() {
    var that = this;
    var url = this.url.replace('{y}', this.year).replace('{m}', this.month).replace('{front}', this.front);
    $.ajax({
      url: url,
      success: function(data) {
        $('#'+that.container).html(data);
        getTriangle();
        verifyAgency();
      }
    });
  }

  this.getInfo = function(day) {
    day.append('<div class="hover hover-tile"><img src="/assets/img/console/spinner.gif" width="15"></div>');
    var that = this,
    id = ""+this.year+this.month+day.data('day')+day.data('cottageid')+this.cottageId,
    url = this.dayInfoUrl
      .replace('{y}', this.year)
      .replace('{m}', this.month)
      .replace('{d}', day.data('day'))
      .replace('{rid}', day.data('cottageid'))
      .replace('{cid}', this.cottageId);
    if (that.cache[id] != undefined){
      day.children('.hover').html(this.cache[id]);
    }
    else{
      $.ajax({
        url: url,
        dataType: 'json',
        success: function(data) {
          day.children('.hover').html(data);
          that.cache[id] = data;
        }
      });
    }
  }

  this.removeInfo = function(day) {
    day.children('.hover').remove();
  }

  this.init = function(showInfo) {
    if (showInfo == false)
      isAgent = true;
    this.showInfo =  typeof showInfo !== 'undefined' ? showInfo : true;
    var that = this;
    that.getCalendar();
    $(document).on('click', '#'+this.container+' #cal-previous', function() {
      that.previousMonth();
    });
    $(document).on('click', '#'+this.container+' #cal-next', function() {
      that.nextMonth();
    });
    if (that.showInfo)
      $(document).on('mouseenter', '#'+this.container+' .detailed', function() {
        that.getInfo($(this));
      });
    $(document).on('mouseleave', '#'+this.container+' .detailed', function() {
      that.removeInfo($(this));
    });
  }
}
function getTriangle(){
  $('table.apiCalendar .day.first').append("<div class='triangle triangleFirst'></div>");
  $('table.apiCalendar .day.last').append("<div class='triangle triangleLast'></div>");

  $('table.apiCalendar .day.firstpro').append("<div class='triangle triangleFirst'></div>");
  $('table.apiCalendar .day.lastpro').append("<div class='triangle triangleLast'></div>");

  $('table.apiCalendar .day.firstother').append("<div class='triangle triangleFirst'></div>");
  $('table.apiCalendar .day.lastother').append("<div class='triangle triangleLast'></div>");

  $('table.apiCalendar .day.firstagency').append("<div class='triangle triangleFirst'></div>");
  $('table.apiCalendar .day.lastagency').append("<div class='triangle triangleLast'></div>");

  $('table.apiCalendar .day.firstblocked').append("<div class='triangle triangleFirst'></div>");
  $('table.apiCalendar .day.lastblocked').append("<div class='triangle triangleLast'></div>");

  var caseHeightFirst = $('table.apiCalendar .day.first').innerHeight();
  var caseWidthFirst = $('table.apiCalendar .day.first').innerWidth();
  var caseHeightLast = $('table.apiCalendar .day.last').innerHeight();
  var caseWidthLast = $('table.apiCalendar .day.last').innerWidth();

  var caseHeight2First = $('table.apiCalendar .day.firstpro').innerHeight();
  var caseWidth2First = $('table.apiCalendar .day.firstpro').innerWidth();
  var caseHeight2Last = $('table.apiCalendar .day.lastpro').innerHeight();
  var caseWidth2Last = $('table.apiCalendar .day.lastpro').innerWidth();

  var caseHeight3First = $('table.apiCalendar .day.firstother').innerHeight();
  var caseWidth3First = $('table.apiCalendar .day.firstother').innerWidth();
  var caseHeight3Last = $('table.apiCalendar .day.lastother').innerHeight();
  var caseWidth3Last = $('table.apiCalendar .day.lastother').innerWidth();

  var caseHeight4First = $('table.apiCalendar .day.firstblocked').innerHeight();
  var caseWidth4First = $('table.apiCalendar .day.firstblocked').innerWidth();
  var caseHeight4Last = $('table.apiCalendar .day.lastblocked').innerHeight();
  var caseWidth4Last = $('table.apiCalendar .day.lastblocked').innerWidth();

  var caseHeight5First = $('table.apiCalendar .day.firstagency').innerHeight();
  var caseWidth5First = $('table.apiCalendar .day.firstagency').innerWidth();
  var caseHeight5Last = $('table.apiCalendar .day.lastagency').innerHeight();
  var caseWidth5Last = $('table.apiCalendar .day.lastagency').innerWidth();

  var myBorderWidth = "0 "+"0 "+caseHeightFirst+"px "+caseWidthFirst+"px";
  var myBorderWidth2 = caseHeightLast+"px "+caseWidthLast+"px 0"+" 0";

  var myBorderWidth11 = "0 "+"0 "+caseHeight2First+"px "+caseWidth2First+"px";
  var myBorderWidth12 = caseHeight2Last+"px "+caseWidth2Last+"px 0"+" 0";

  var myBorderWidth21 = "0 "+"0 "+caseHeight3First+"px "+caseWidth3First+"px";
  var myBorderWidth22 = caseHeight3Last+"px "+caseWidth3Last+"px 0"+" 0";

  var myBorderWidth31 = "0 "+"0 "+caseHeight4First+"px "+caseWidth4First+"px";
  var myBorderWidth32 = caseHeight4Last+"px "+caseWidth4Last+"px 0"+" 0";

  var myBorderWidth41 = "0 "+"0 "+caseHeight5First+"px "+caseWidth5First+"px";
  var myBorderWidth42 = caseHeight5Last+"px "+caseWidth5Last+"px 0"+" 0";


  $('table.apiCalendar .day.first .triangle').css("border-width",myBorderWidth);
  $('table.apiCalendar .day.last .triangle').css("border-width",myBorderWidth2);

  $('table.apiCalendar .day.firstpro .triangle').css("border-width",myBorderWidth11);
  $('table.apiCalendar .day.lastpro .triangle').css("border-width",myBorderWidth12);

  $('table.apiCalendar .day.firstother .triangle').css("border-width",myBorderWidth21);
  $('table.apiCalendar .day.lastother .triangle').css("border-width",myBorderWidth22);

  $('table.apiCalendar .day.firstblocked .triangle').css("border-width",myBorderWidth31);
  $('table.apiCalendar .day.lastblocked .triangle').css("border-width",myBorderWidth32);

  $('table.apiCalendar .day.firstagency .triangle').css("border-width",myBorderWidth41);
  $('table.apiCalendar .day.lastagency .triangle').css("border-width",myBorderWidth42);
}

function verifyAgency() {
  if (isAgent) {
    $('.day.firstother').addClass('first').removeClass('firstother');
    $('.day.other').addClass('reserved').removeClass('other');
    $('.day.lastother').addClass('last').removeClass('lastother');
    $('.day.firstagency').addClass('first').removeClass('firstagency');
    $('.day.reservedagency').addClass('reserved').removeClass('reservedagency');
    $('.day.lastagency').addClass('last').removeClass('lastagency');
    $('.day.firstpro').addClass('first').removeClass('firstpro');
    $('.day.reservedpro').addClass('reserved').removeClass('reservedpro');
    $('.day.lastpro').addClass('last').removeClass('lastpro');
  }

}

$( window ).resize(function() {
  getTriangle();
});


